export enum WorkflowType {
    Client,
    Service,
    Both
}
